import _ from "underscore";

function byId(array, key = "id") {
  return _.mapObject(_.groupBy(array, key), el => el[0]);
}

export default byId;
